import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import SearchIcon from '@mui/icons-material/Search';
import * as XLSX from 'xlsx';
import { fetchData, deleteData, activateData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import { IconButton } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import { Link } from 'react-router-dom'; // Import Link from react-router-dom
import Button from '@mui/material/Button';
import RefreshIcon from '@mui/icons-material/Refresh';
import FeedIcon from '@mui/icons-material/Feed';
import Select from 'react-select'; // Import react-select
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';

function Ledger() {
    const [dataBill, setDataBill] = useState([]);
    const [dataItem, setDataItem] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [showSearchInput, setShowSearchInput] = useState(false);
    const tableRef = React.createRef();
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [selectedOption, setSelectedOption] = useState('itemWise');
    const [customerId, setCustomer] = useState('');
    const { isAuthenticated, companyId, companyName, branchId, permissions, token, logout } = useAuth();
    const [reportGeneratedTime, setReportGeneratedTime] = useState('');

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
        setFromDate(getFormattedStartDate());
        setToDate(getFormattedCurrentDate());
        fetchMasterType();
        //fetchCustomerData();
    }, [isAuthenticated, companyId, token, logout]);

    //  Master Type

    const [masterTypeOptions, setMasterTypeOptions] = useState([]);
    const [selectedMasterType, setSelectedMasterType] = useState("");
    const [selectedMaster, setSelectedMaster] = useState("");
    // const [selectedMasterType, setSelectedMasterType] = useState(null);

    const fetchMasterType = async () => {
        try {

            const id = 0; // Replace with the actual ID you want to fetch
            const response = await fetchData('MasterApi', `/MasterTypeData/${companyId}`, token);
            if (response.responseCode === '1111') {

                const options = response.response_data.map(item => ({
                    value: item.Id,
                    label: item.Name
                }));
                setMasterTypeOptions(options);
            }
        } catch (error) {
            console.error('Error fetching Master :', error);
        }
    };

    const [accountheadOptions, setAccountHeadOptions] = useState([]);
    const [selectedAccountHead, setSelectedAccountHead] = useState(null);
    const [AssetOptions, setAssetOptions] = useState([]);
    const [selectedAsset, setSelectedAsset] = useState(null);
    const [bankOptions, setBankOptions] = useState([]);
    const [selectedBank, setSelectedBank] = useState("");
    const [capitalOptions, setCapitalOptions] = useState([]);
    const [selectedCapital, setSelectedCapital] = useState("");
    const [supplierOptions, setSupplierOptions] = useState([]);
    const [selectedSupplier, setSelectedSupplier] = useState("");
    const [OtherOptions, setOtherOptions] = useState([]);
    const [selectedOther, setSelectedOther] = useState("");
    const [StaffOptions, setStaffOptions] = useState([]);
    const [selectedStaff, setSelectedStaff] = useState("");

    const handleMasterTypeChange = async (selectedOption) => {
        setSelectedMasterType(selectedOption);
        setSelectedMaster(selectedOption.value);
        const selectedLabel = selectedOption.value;
        setDataItem([]);  // Clear previous data
        setSelectedMasterChild(''); // Clear selected master child
        try {
            // Call the fetch function based on selected master type
            const fetchFunctions = {
                // 1: fetchAccountHead,
                // 2: fetchAsset,
                // 3: fetchBank,
                // 4: fetchCapital,
                // 5: fetchSupplier,
                // 6: fetchOther,
                // default: fetchStaff

                1: fetchCapital,
                2: fetchSupplier,
                3: fetchBank,
                4: fetchAccountHead,
                5: fetchOther,

                default: fetchStaff
            };

            const fetchFunction = fetchFunctions[selectedLabel] || fetchFunctions.default;
            fetchFunction();

        } catch (error) {
            console.error('Error fetching Master Child Details:', error);
        }
    };


    const fetchDataForMasterType = async (api, params) => {
        try {
            const response = await fetchData(api, `/${companyId}/${params}`, token);
            if (response.responseCode === '1111') {
                const options = response.response_data.map(item => ({
                    value: item.masterId,
                    label: item.name
                }));
                return options;
            }
        } catch (error) {
            console.error(`Error fetching ${api}:`, error);
        }
    };

    const fetchAccountHead = async () => {
        const options = await fetchDataForMasterType('AccountHeadApi', selectedMaster);
        setAccountHeadOptions(options);
    };

    const fetchAsset = async () => {
        const options = await fetchDataForMasterType('AssetsApi', selectedMaster);
        setAssetOptions(options);
    };

    const fetchBank = async () => {
        const options = await fetchDataForMasterType('BankApi', selectedMaster);
        setBankOptions(options);
    };

    const fetchCapital = async () => {
        const options = await fetchDataForMasterType('CapitalApi', selectedMaster);
        setCapitalOptions(options);
    };

    const fetchSupplier = async () => {
        const options = await fetchDataForMasterType('SupplierApi', selectedMaster);
        setSupplierOptions(options);
    };

    const fetchOther = async () => {
        const options = await fetchDataForMasterType('MasterApi', selectedMaster);
        setOtherOptions(options);
    };

    const fetchStaff = async () => {
        const options = await fetchDataForMasterType('StaffApi', selectedMaster);
        setStaffOptions(options);
    };

    useEffect(() => {
        if (selectedMaster && masterTypeOptions.length > 0) {
            const foundOption = masterTypeOptions.find(opt => opt.value === selectedMaster);
            if (foundOption) {
                handleMasterTypeChange(foundOption); // ✅ Pass full object
            }
        }
    }, [selectedMaster, masterTypeOptions]);


    const [selectedMasterChild, setSelectedMasterChild] = useState('');
    const [selectedMasterChildlabel, setSelectedMasterChildlabel] = useState('');

    const handleAccountHeadChange = (selectedOption) => {
        setSelectedAccountHead(selectedOption);
        setSelectedMasterChild(selectedOption.value);
        setSelectedMasterChildlabel(selectedOption.label);
        setDataItem([]);  // Clear previous data

        // Directly use the selectedOption.value to fetch data
        // fetchLedgerData(selectedOption.value);
    };

    const handleAssetChange = async (selectedOption) => {
        setSelectedAsset(selectedOption);
        setSelectedMasterChild(selectedOption.value);
        setSelectedMasterChildlabel(selectedOption.label);
        setDataItem([]);  // Clear previous data

        // Directly use the selectedOption.value to fetch data
        // fetchLedgerData(selectedMasterChild);
    };

    const handleBankChange = async (selectedOption) => {
        setSelectedBank(selectedOption);
        setSelectedMasterChild(selectedOption.value);
        setSelectedMasterChildlabel(selectedOption.label);
        setDataItem([]);  // Clear previous data

        // Directly use the selectedOption.value to fetch data
        // fetchLedgerData(selectedMasterChild);
    };

    const handleCapitalChange = async (selectedOption) => {
        setSelectedCapital(selectedOption);
        setSelectedMasterChild(selectedOption.value);
        setSelectedMasterChildlabel(selectedOption.label);
        setDataItem([]);  // Clear previous data

        // Directly use the selectedOption.value to fetch data
        // fetchLedgerData(selectedMasterChild);
    };


    const handleSupplierChange = async (selectedOption) => {
        setSelectedSupplier(selectedOption);
        setSelectedMasterChild(selectedOption.value);
        setSelectedMasterChildlabel(selectedOption.label);
        setDataItem([]);  // Clear previous data

        // Directly use the selectedOption.value to fetch data
        //  fetchLedgerData(selectedMasterChild);
    };

    const handleOtherChange = async (selectedOption) => {
        setSelectedOther(selectedOption);
        setSelectedMasterChild(selectedOption.value);
        setSelectedMasterChildlabel(selectedOption.label);
        setDataItem([]);  // Clear previous data

        // Directly use the selectedOption.value to fetch data
        // fetchLedgerData(selectedMasterChild);
    };

    const handleStaffChange = async (selectedOption) => {
        setSelectedStaff(selectedOption);
        setSelectedMasterChild(selectedOption.value);
        setSelectedMasterChildlabel(selectedOption.label);
        setDataItem([]);  // Clear previous data

        // Directly use the selectedOption.value to fetch data
        // fetchLedgerData(selectedMasterChild);
    };


    const getFormattedCurrentDate = () => {
        const currentDate = new Date();
        return currentDate.toISOString().split('T')[0];
    };

    const getFormattedStartDate = () => {
        const monthStartDate = new Date();
        monthStartDate.setDate(1);
        return monthStartDate.toISOString().split('T')[0];
    };

    const fetchTableData = async () => {
        const now = new Date();
        const formattedDateTime =
            String(now.getDate()).padStart(2, '0') + '-' +
            String(now.getMonth() + 1).padStart(2, '0') + '-' +
            now.getFullYear() + ' ' +
            now.toLocaleTimeString(); // e.g., 10:45:23 AM

        setReportGeneratedTime(formattedDateTime);

        setDataItem([])
        try {
            const masterChildValue = selectedMasterChild;
            const response = await fetchData('ReportApi', `/Ledger/${fromDate}/${toDate}/${companyId}/${branchId}/${masterChildValue}`, token);
            if (response.responseCode === '1111') {
                setDataItem(response.response_data);

            }
        } catch (error) {
            console.error('Error fetching Ledger Details:', error);
        }

    };

    const handleFromDateChange = (e) => {
        const selectedDate = e.target.value;
        // Add validation if needed
        setFromDate(selectedDate);
    };

    // Similar function for toDate
    const handleToDateChange = (e) => {
        const selectedDate = e.target.value;
        // Add validation if needed
        setToDate(selectedDate);
    };

    const hasReadReportPermission = permissions.includes('Read Reports');

    const handleChange = (event) => {
        setSelectedOption(event.target.value);
    };

    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    const toggleSearchInput = () => {
        setShowSearchInput(!showSearchInput);
    };

    const filteredDataBill = dataBill.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    const filteredDataItem = dataItem.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    const formatDate = (dateString) => {
        const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
        return new Date(dateString).toLocaleDateString('en-GB', options);
    };

    const formatDateForInput = (dateString) => {
        const currentDate = new Date(dateString);;
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, '0');
        const day = String(currentDate.getDate()).padStart(2, '0');
        const formattedDate = `${day}-${month}-${year}`;

        return formattedDate;
    };

    // const handleExportExcel = () => {
    //     const excelData = [];
    //     let copbal = 0; // Cumulative opening balance for credit
    //     let dopbal = 0; // Cumulative opening balance for debit
    //     let bal = 0;    // Running balance

    //     // Helper function to compute balance
    //     const computeBalance = (data) => {
    //         // if (data.description1 === 'Opening Balance') {
    //         //     bal = 0; // Reset balance for opening balance
    //         // } else 
    //         if (data.description1 !== 'Closing Balance' && data.description1 !== 'Total') {
    //             // Add debit to balance
    //             if (data.debit) {
    //                 bal += Math.abs(data.debit);
    //             }
    //             // Subtract credit from balance
    //             if (data.credit) {
    //                 bal -= Math.abs(data.credit);
    //             }
    //         }

    //         // Return balance string with "Dr" or "Cr"
    //         //data.description1 !== 'Opening Balance' &&
    //         if (data.description1 !== 'Closing Balance' && data.description1 !== 'Total') {
    //             return bal > 0 ? `${bal.toFixed(2)} Dr` : `${Math.abs(bal).toFixed(2)} Cr`;
    //         }
    //         return '';
    //     };



    //     const customerLabel = selectedMasterChildlabel || 'All Customers'; // Use selected label or default to 'All Customers'
    //     const now = new Date();
    //     const formattedDateTime = `${now.toLocaleDateString()} ${now.toLocaleTimeString()}`;


    //     // Add header caption
    //     const headerCaption = [
    //         [`Ledger for  ${customerLabel} From : ${formatDate(fromDate)} To: ${formatDate(toDate)} | Generated On: ${formattedDateTime} By : ${username}`]
    //     ];
    //     excelData.push(...headerCaption);

    //     // Add column headers
    //     const headerRow = ['Date', 'Description', 'Debit', 'Credit', 'Balance'];
    //     excelData.push(headerRow);

    //     // Add data rows
    //     filteredDataItem.forEach((rowData) => {
    //         const dataRow = [];
    //         if (rowData.description1 === 'Opening Balance') {
    //             // Display balances under Debit and Credit columns
    //             dataRow.push(
    //                 '', // Empty date
    //                 rowData.description1,
    //                 rowData.debit != null ? rowData.debit.toFixed(2) : '',
    //                 rowData.credit != null ? rowData.credit.toFixed(2) : '',
    //                 computeBalance(rowData)
    //             );

    //         } else if (rowData.description1 === 'Closing Balance') {
    //             // Display Total directly under Debit and Credit columns
    //             dataRow.push(
    //                 '', // Empty date
    //                 rowData.description1,
    //                 rowData.debit != null ? rowData.debit.toFixed(2) : '',
    //                 rowData.credit != null ? rowData.credit.toFixed(2) : '',
    //                 '' // No balance for Total rows
    //             );
    //         }

    //         else if (rowData.description1 === 'Total') {
    //             // Display Total directly under Debit and Credit columns
    //             dataRow.push(
    //                 '', // Empty date
    //                 rowData.description1,
    //                 rowData.debit != null ? rowData.debit.toFixed(2) : '',
    //                 rowData.credit != null ? rowData.credit.toFixed(2) : '',
    //                 '' // No balance for Total rows
    //             );
    //         } else {
    //             // For regular rows
    //             dataRow.push(
    //                 formatDateForInput(rowData.date1), // Format the date
    //                 rowData.description1,
    //                 rowData.debit != null ? parseFloat(rowData.debit.toFixed(2)) : '',
    //                 rowData.credit != null ? parseFloat(rowData.credit.toFixed(2)) : '',
    //                 computeBalance(rowData) // Compute and add balance
    //             );
    //         }
    //         excelData.push(dataRow);
    //     });

    //     // Create a worksheet
    //     const worksheet = XLSX.utils.aoa_to_sheet(excelData);

    //     // Style the worksheet to right-align specific columns
    //     const columnIndexesToRightAlign = [2, 3, 4, 5]; // Debit, Credit, and Balance columns
    //     const range = XLSX.utils.decode_range(worksheet['!ref']);

    //     for (let row = 1; row <= range.e.r; row++) { // Start from row 1 (skip header)
    //         columnIndexesToRightAlign.forEach((colIndex) => {
    //             const cellAddress = XLSX.utils.encode_cell({ r: row, c: colIndex });
    //             if (worksheet[cellAddress]) {
    //                 worksheet[cellAddress].s = { alignment: { horizontal: 'right' } };
    //             }
    //         });
    //     }

    //     // Use XLSX library to create and download the Excel file

    //     const workbook = XLSX.utils.book_new();
    //     XLSX.utils.book_append_sheet(workbook, worksheet, 'Ledger');

    //     // Filename sanitization for spaces and special characters
    //     const sanitizedCustomerLabel = customerLabel.replace(/[^\w]/g, '_');
    //     XLSX.writeFile(workbook, `Ledger_${sanitizedCustomerLabel}.xlsx`);
    // };

    // const handleExportExcel = async () => {
    //     const workbook = new ExcelJS.Workbook();
    //     const worksheet = workbook.addWorksheet('Ledger');
    //     worksheet.views = [
    //         { state: 'frozen', xSplit: 0, ySplit: 2 } // fixed header
    //     ];
    //     let bal = 0;

    //     const computeBalance = (data) => {
    //         if (data.description1 !== 'Closing Balance' && data.description1 !== 'Total') {
    //             if (data.debit) bal += Math.abs(data.debit);
    //             if (data.credit) bal -= Math.abs(data.credit);
    //         }

    //         if (data.description1 !== 'Closing Balance' && data.description1 !== 'Total') {
    //             return bal > 0 ? `${bal.toFixed(2)} Dr` : `${Math.abs(bal).toFixed(2)} Cr`;
    //         }
    //         return '';
    //     };

    //     const customerLabel = selectedMasterChildlabel || 'All Customers';
    //     const now = new Date();
    //     const formattedDateTime = `${now.toLocaleDateString()} ${now.toLocaleTimeString()}`;

    //     const thinBorder = {
    //         top: { style: 'thin' },
    //         left: { style: 'thin' },
    //         bottom: { style: 'thin' },
    //         right: { style: 'thin' },
    //     };

    //     // Header Title Row
    //     worksheet.mergeCells('A1:E1');
    //     const headerCell = worksheet.getCell('A1');
    //     headerCell.value = `${companyName} - Ledger for ${customerLabel} From: ${formatDate(fromDate)} To: ${formatDate(toDate)} | Generated On: ${formattedDateTime}`;
    //     //headerCell.value = `Ledger for ${customerLabel} From: ${formatDate(fromDate)} To: ${formatDate(toDate)} | Generated On: ${formattedDateTime}`;
    //     headerCell.font = { bold: true, size: 10 };
    //     headerCell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };

    //     // Column Headers
    //     const headerRow = worksheet.addRow(['Date', 'Description', 'Debit', 'Credit', 'Balance']);
    //     headerRow.eachCell((cell) => {
    //         cell.font = { bold: true };
    //         cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
    //         cell.border = thinBorder;
    //         cell.fill = {
    //             type: 'pattern',
    //             pattern: 'solid',
    //             fgColor: { argb: 'FFD9EAD3' }, // Light green fill
    //         };
    //     });

    //     // Data Rows
    //     filteredDataItem.forEach((rowData) => {
    //         let rowValues;

    //         if (rowData.description1 === 'Opening Balance' || rowData.description1 === 'Closing Balance' || rowData.description1 === 'Total') {
    //             rowValues = [
    //                 '', // No date
    //                 rowData.description1,
    //                 rowData.debit != null ? rowData.debit.toFixed(2) : '',
    //                 rowData.credit != null ? rowData.credit.toFixed(2) : '',
    //                 rowData.description1 === 'Opening Balance' ? computeBalance(rowData) : ''
    //             ];
    //         } else {
    //             rowValues = [
    //                 formatDateForInput(rowData.date1),
    //                 rowData.description1,
    //                 rowData.debit != null ? rowData.debit.toFixed(2) : '',
    //                 rowData.credit != null ? rowData.credit.toFixed(2) : '',
    //                 computeBalance(rowData)
    //             ];
    //         }

    //         const row = worksheet.addRow(rowValues);
    //         row.eachCell((cell, colNumber) => {
    //             // Align Debit, Credit, Balance right
    //             if ([3, 4, 5].includes(colNumber)) {
    //                 cell.alignment = { horizontal: 'right' };
    //                 cell.numFmt = '#,##0.00';
    //             } else {
    //                 cell.alignment = { horizontal: 'left' };
    //             }
    //             cell.border = thinBorder;
    //         });
    //     });

    //     worksheet.columns.forEach((column) => {
    //         column.width = 20; // Set all columns to a normal width (adjust 20 as needed)
    //     });

    //     // Export to file
    //     const buffer = await workbook.xlsx.writeBuffer();
    //     const sanitizedCustomerLabel = customerLabel.replace(/[^\w]/g, '_');
    //     saveAs(
    //         new Blob([buffer]),
    //         `Ledger_${sanitizedCustomerLabel}_${formatDate(fromDate).replace(/\//g, '-')}_To_${formatDate(toDate).replace(/\//g, '-')}.xlsx`
    //     );
    // };
    // const fileName = `Cash_Book_From_${formatDate(fromDate).replace(/\//g, '-')}_To_${formatDate(toDate).replace(/\//g, '-')}.xlsx`;

    const handleExportExcel = async () => {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Ledger');
        worksheet.views = [
            { state: 'frozen', xSplit: 0, ySplit: 2 }
        ];
        let bal = 0;

        const computeBalance = (data) => {
            if (data.description1 !== 'Closing Balance' && data.description1 !== 'Total') {
                if (data.debit) bal += Math.abs(data.debit);
                if (data.credit) bal -= Math.abs(data.credit);
            }

            if (data.description1 !== 'Closing Balance' && data.description1 !== 'Total') {
                return bal > 0 ? `${bal.toFixed(2)} Dr` : `${Math.abs(bal).toFixed(2)} Cr`;
            }
            return '';
        };

        const customerLabel = selectedMasterChildlabel || 'All Customers';
        const now = new Date();
        const formattedDateTime = `${now.toLocaleDateString()} ${now.toLocaleTimeString()}`;

        const thinBorder = {
            top: { style: 'thin' },
            left: { style: 'thin' },
            bottom: { style: 'thin' },
            right: { style: 'thin' },
        };

        // Header Title Row
        worksheet.mergeCells('A1:E1');
        const headerCell = worksheet.getCell('A1');
        headerCell.value = `${companyName} - Ledger for ${customerLabel} From: ${formatDate(fromDate)} To: ${formatDate(toDate)} | Generated On: ${formattedDateTime}`;
        headerCell.font = { bold: true, size: 10 };
        headerCell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };

        // Column Headers
        const headerRow = worksheet.addRow(['Date', 'Description', 'Debit', 'Credit', 'Balance']);
        headerRow.eachCell((cell) => {
            cell.font = { bold: true };
            cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
            cell.border = thinBorder;
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFD9EAD3' }, // Light green
            };
        });

        // Data Rows
        filteredDataItem.forEach((rowData) => {
            let rowValues;

            if (rowData.description1 === 'Opening Balance' || rowData.description1 === 'Closing Balance' || rowData.description1 === 'Total') {
                rowValues = [
                    '',
                    rowData.description1,
                    rowData.debit != null ? rowData.debit.toFixed(2) : '',
                    rowData.credit != null ? rowData.credit.toFixed(2) : '',
                    rowData.description1 === 'Opening Balance' ? computeBalance(rowData) : ''
                ];
            } else {
                rowValues = [
                    formatDateForInput(rowData.date1),
                    rowData.description1,
                    rowData.debit != null ? rowData.debit.toFixed(2) : '',
                    rowData.credit != null ? rowData.credit.toFixed(2) : '',
                    computeBalance(rowData)
                ];
            }

            const row = worksheet.addRow(rowValues);

            if (rowData.description1 === 'Closing Balance' || rowData.description1 === 'Total') {
                row.eachCell((cell) => {
                    cell.fill = {
                        type: 'pattern',
                        pattern: 'solid',
                        fgColor: { argb: 'FFF4CCCC' }, // Light pink
                    };
                    cell.font = { bold: true };
                    cell.border = thinBorder;
                    cell.alignment = { horizontal: 'right', vertical: 'middle', wrapText: true };
                });
            } else {
                row.eachCell((cell, colNumber) => {
                    if ([3, 4, 5].includes(colNumber)) {
                        cell.alignment = { horizontal: 'right' };
                        cell.numFmt = '#,##0.00';
                    } else {
                        cell.alignment = { horizontal: 'left' };
                    }
                    cell.border = thinBorder;
                });
            }
        });

        worksheet.columns.forEach((column) => {
            column.width = 20;
        });

        // Export to file
        const buffer = await workbook.xlsx.writeBuffer();
        const sanitizedCustomerLabel = customerLabel.replace(/[^\w]/g, '_');
        saveAs(
            new Blob([buffer]),
            `Ledger_${sanitizedCustomerLabel}_${formatDate(fromDate).replace(/\//g, '-')}_To_${formatDate(toDate).replace(/\//g, '-')}.xlsx`
        );
    };


    let copbal = 0; // Cumulative opening balance for credit
    let dopbal = 0; // Cumulative opening balance for debit
    let bal = 0;    // Running balance

    const computeBalance = (data) => {

        if (data.description1 !== 'Closing Balance' && data.description1 !== 'Total') {
            // Add debit to balance
            if (data.debit) {
                bal += Math.abs(data.debit);
            }
            // Subtract credit from balance
            if (data.credit) {
                bal -= Math.abs(data.credit);
            }
        }

        // Return balance string with "Dr" or "Cr"
        if (data.description1 !== 'Closing Balance' && data.description1 !== 'Total') {
            return bal > 0 ? `${bal.toFixed(2)}  Dr` : `${Math.abs(bal).toFixed(2)}  Cr`;
        }
        return '';
    };
    return (

        <div className="w-full  mx-auto" style={{ width: '95%', marginTop: '10px' }}>

            <h6 className="uppercase tracking-wide text-black font-serif flex-grow" style={{
                fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif',
                color: 'black',
                marginTop: '10px',
            }}>
                Ledger
            </h6>
            {reportGeneratedTime && (
                <div className="text-sm text-gray-600" style={{ marginTop: '5px', marginRight: '100px' }}>
                    Report Generated: {reportGeneratedTime}
                </div>
            )}
            <br />
            <div style={{ display: 'flex', flexWrap: 'nowrap', marginBottom: '16px', marginLeft: '5px' }}>
                <div style={{ flex: '2', maxWidth: '12%', paddingRight: '8px', marginBottom: '0', marginTop: '-15px' }}>
                    <label className="block uppercase tracking-wide text-black text-xs  mb-2" htmlFor="fromDate" style={{ fontSize: '11px' }}>
                        From Date
                    </label>
                    <input
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                        type="date" value={fromDate} onChange={handleFromDateChange}
                    />
                </div>

                <div style={{ flex: '2', maxWidth: '12%', marginLeft: '8px', marginBottom: '0', marginTop: '-15px' }}>
                    <label className="block uppercase tracking-wide text-black text-xs  mb-2" htmlFor="toDate" style={{ fontSize: '11px' }}>
                        To Date
                    </label>
                    <input
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                        type="date" value={toDate} onChange={handleToDateChange}
                    />
                </div>

                <div style={{ flex: '3', maxWidth: '17%', paddingRight: '8px', marginBottom: '0', marginTop: '-15px', marginLeft: '8px' }}>
                    <label className="block uppercase tracking-wide text-black text-xs  mb-2" htmlFor="fromDate" style={{ fontSize: '11px' }}>
                        Master Type <span className="text-red-500">*</span>
                    </label>
                    <Select
                        value={selectedMasterType}
                        onChange={handleMasterTypeChange}
                        options={masterTypeOptions}
                        placeholder="Master Type"
                        isSearchable
                        menuPortalTarget={document.body}   // 👈 forces dropdown outside container
                        styles={{
                            control: (base) => ({
                                ...base,
                                minHeight: "30px",
                                height: "30px",
                                fontSize: "14px",
                            }),
                            valueContainer: (base) => ({
                                ...base,
                                height: "30px",
                                padding: "0 6px",
                            }),
                            indicatorsContainer: (base) => ({
                                ...base,
                                height: "30px",
                            }),
                            menuPortal: (base) => ({ ...base, zIndex: 2000 }), // 👈 make sure it overlays dialog
                            menu: (provided) => ({
                                ...provided,
                                fontSize: "14px",
                            }),
                        }}
                    />
                </div>

                <div style={{ flex: '3', maxWidth: '25%', paddingRight: '8px', marginBottom: '0', marginTop: '-15px' }}>

                    {/* Account Head Dropdown */}
                    {selectedMasterType.value === 4 && (
                        <div className="flex-1 w-2/2 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs  mb-2" htmlFor="customer" style={{ fontSize: '11px' }}>
                                Account Head <span className="text-red-500">*</span>
                            </label>
                            <Select
                                value={selectedAccountHead}
                                onChange={handleAccountHeadChange}
                                options={accountheadOptions}
                                placeholder="Select Account Head"
                                isSearchable
                                menuPortalTarget={document.body}   // 👈 forces dropdown outside container
                                styles={{
                                    control: (base) => ({
                                        ...base,
                                        minHeight: "30px",
                                        height: "30px",
                                        fontSize: "14px",
                                    }),
                                    valueContainer: (base) => ({
                                        ...base,
                                        height: "30px",
                                        padding: "0 6px",
                                    }),
                                    indicatorsContainer: (base) => ({
                                        ...base,
                                        height: "30px",
                                    }),
                                    menuPortal: (base) => ({ ...base, zIndex: 2000 }), // 👈 make sure it overlays dialog
                                    menu: (provided) => ({
                                        ...provided,
                                        fontSize: "14px",
                                    }),
                                }}
                            />
                        </div>
                    )}

                    {/* Asset Dropdown */}
                    {selectedMasterType.value === 6 && (
                        <div className="flex-1 w-2/2 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs  mb-2" htmlFor="customer" style={{ fontSize: '11px' }}>
                                Asset <span className="text-red-500">*</span>
                            </label>
                            <Select
                                value={selectedAsset}
                                onChange={handleAssetChange}
                                options={AssetOptions}
                                placeholder="Select Asset"
                                isSearchable
                                menuPortalTarget={document.body}   // 👈 forces dropdown outside container
                                styles={{
                                    control: (base) => ({
                                        ...base,
                                        minHeight: "30px",
                                        height: "30px",
                                        fontSize: "14px",
                                    }),
                                    valueContainer: (base) => ({
                                        ...base,
                                        height: "30px",
                                        padding: "0 6px",
                                    }),
                                    indicatorsContainer: (base) => ({
                                        ...base,
                                        height: "30px",
                                    }),
                                    menuPortal: (base) => ({ ...base, zIndex: 2000 }), // 👈 make sure it overlays dialog
                                    menu: (provided) => ({
                                        ...provided,
                                        fontSize: "14px",
                                    }),
                                }}
                            />
                        </div>
                    )}

                    {/* Bank Dropdown */}
                    {selectedMasterType.value === 3 && (
                        <div className="flex-1 w-2/2 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs  mb-2" htmlFor="customer" style={{ fontSize: '11px' }}>
                                Bank <span className="text-red-500">*</span>
                            </label>
                            <Select
                                value={selectedBank}
                                onChange={handleBankChange}
                                options={bankOptions}
                                placeholder="Select Bank"
                                isSearchable
                                menuPortalTarget={document.body}   // 👈 forces dropdown outside container
                                styles={{
                                    control: (base) => ({
                                        ...base,
                                        minHeight: "30px",
                                        height: "30px",
                                        fontSize: "14px",
                                    }),
                                    valueContainer: (base) => ({
                                        ...base,
                                        height: "30px",
                                        padding: "0 6px",
                                    }),
                                    indicatorsContainer: (base) => ({
                                        ...base,
                                        height: "30px",
                                    }),
                                    menuPortal: (base) => ({ ...base, zIndex: 2000 }), // 👈 make sure it overlays dialog
                                    menu: (provided) => ({
                                        ...provided,
                                        fontSize: "14px",
                                    }),
                                }}
                            />
                        </div>
                    )}

                    {/* Capital Dropdown */}
                    {selectedMasterType.value === 1 && (
                        <div className="flex-1 w-2/2 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs  mb-2" htmlFor="customer" style={{ fontSize: '11px' }}>
                                Capital <span className="text-red-500">*</span>
                            </label>
                            <Select
                                value={selectedCapital}
                                onChange={handleCapitalChange}
                                options={capitalOptions}
                                placeholder="Select Capital"
                                isSearchable
                                menuPortalTarget={document.body}   // 👈 forces dropdown outside container
                                styles={{
                                    control: (base) => ({
                                        ...base,
                                        minHeight: "30px",
                                        height: "30px",
                                        fontSize: "14px",
                                    }),
                                    valueContainer: (base) => ({
                                        ...base,
                                        height: "30px",
                                        padding: "0 6px",
                                    }),
                                    indicatorsContainer: (base) => ({
                                        ...base,
                                        height: "30px",
                                    }),
                                    menuPortal: (base) => ({ ...base, zIndex: 2000 }), // 👈 make sure it overlays dialog
                                    menu: (provided) => ({
                                        ...provided,
                                        fontSize: "14px",
                                    }),
                                }}
                            />
                        </div>
                    )}

                    {/* Supplier Or Customer Dropdown */}
                    {selectedMasterType.value === 2 && (
                        <div className="flex-1 w-2/2 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs  mb-2" htmlFor="customer" style={{ fontSize: '11px' }}>
                                Supplier<span className="text-red-500">*</span>
                            </label>
                            <Select
                                value={selectedSupplier}
                                onChange={handleSupplierChange}
                                options={supplierOptions}
                                placeholder="Select Supplier"
                                isSearchable
                                menuPortalTarget={document.body}   // 👈 forces dropdown outside container
                                styles={{
                                    control: (base) => ({
                                        ...base,
                                        minHeight: "30px",
                                        height: "30px",
                                        fontSize: "14px",
                                    }),
                                    valueContainer: (base) => ({
                                        ...base,
                                        height: "30px",
                                        padding: "0 6px",
                                    }),
                                    indicatorsContainer: (base) => ({
                                        ...base,
                                        height: "30px",
                                    }),
                                    menuPortal: (base) => ({ ...base, zIndex: 2000 }), // 👈 make sure it overlays dialog
                                    menu: (provided) => ({
                                        ...provided,
                                        fontSize: "14px",
                                    }),
                                }}
                            />
                        </div>
                    )}

                    {/* Capital Dropdown */}
                    {selectedMasterType.value === 5 && (
                        <div className="flex-1 w-2/2 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs  mb-2" htmlFor="customer">
                                Other <span className="text-red-500">*</span>
                            </label>
                            <Select
                                value={selectedOther}
                                onChange={handleOtherChange}
                                options={OtherOptions}
                                placeholder="Select Other"
                                isSearchable
                                menuPortalTarget={document.body}   // 👈 forces dropdown outside container
                                styles={{
                                    control: (base) => ({
                                        ...base,
                                        minHeight: "30px",
                                        height: "30px",
                                        fontSize: "14px",
                                    }),
                                    valueContainer: (base) => ({
                                        ...base,
                                        height: "30px",
                                        padding: "0 6px",
                                    }),
                                    indicatorsContainer: (base) => ({
                                        ...base,
                                        height: "30px",
                                    }),
                                    menuPortal: (base) => ({ ...base, zIndex: 2000 }), // 👈 make sure it overlays dialog
                                    menu: (provided) => ({
                                        ...provided,
                                        fontSize: "14px",
                                    }),
                                }}
                            />
                        </div>
                    )}

                    {/* Staff Dropdown */}
                    {selectedMasterType.value === 7 && (
                        <div className="flex-1 w-2/2 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs  mb-2" htmlFor="customer">
                                Staff <span className="text-red-500">*</span>
                            </label>
                            <Select
                                value={selectedStaff}
                                onChange={handleStaffChange}
                                options={StaffOptions}
                                placeholder="Select Staff"
                                isSearchable
                                menuPortalTarget={document.body}   // 👈 forces dropdown outside container
                                styles={{
                                    control: (base) => ({
                                        ...base,
                                        minHeight: "30px",
                                        height: "30px",
                                        fontSize: "14px",
                                    }),
                                    valueContainer: (base) => ({
                                        ...base,
                                        height: "30px",
                                        padding: "0 6px",
                                    }),
                                    indicatorsContainer: (base) => ({
                                        ...base,
                                        height: "30px",
                                    }),
                                    menuPortal: (base) => ({ ...base, zIndex: 2000 }), // 👈 make sure it overlays dialog
                                    menu: (provided) => ({
                                        ...provided,
                                        fontSize: "14px",
                                    }),
                                }}
                            />
                        </div>
                    )}

                </div>

                <Button
                    style={{
                        background: "linear-gradient(to right, #A8A196,#A8A196)",
                        color: "black",
                        textTransform: "none",
                        boxShadow: "0 4px 6px rgba(0, 0, 0, 0.3)",
                        maxHeight: "30px",
                        marginLeft: "15px",
                        marginTop: '0.90%',
                        borderRadius: "15px",
                    }}
                    onClick={fetchTableData}
                >
                    <b style={{ color: 'white' }}>Refresh</b>
                </Button>

                <Button
                    style={{
                        background: 'linear-gradient(to right, #3F4F44,#3F4F44)',
                        color: 'black',
                        textTransform: 'none',
                        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                        maxHeight: '30px',
                        marginLeft: '15px',
                        marginTop: '0.90%',
                        borderRadius: "15px",
                    }}
                    onClick={handleExportExcel}
                >
                    <b style={{ color: 'white' }}>Excel</b>
                </Button>
            </div>

            <div className='w-full mb-5 flex' style={{ maxHeight: '500px', overflowY: 'auto', marginTop: '-7px' }}>

                <TableContainer component={Paper}>
                    <Table stickyHeader>
                        <TableHead sx={{ backgroundColor: '#102E50' }}>
                            <TableRow>
                                <TableCell sx={{ backgroundColor: '#102E50', borderBottom: '1px solid #ddd', fontSize: '11px', color: 'whitesmoke', padding: '2px', fontWeight: 'bold', textTransform: 'uppercase' }}>Date</TableCell>
                                <TableCell sx={{ backgroundColor: '#102E50', borderBottom: '1px solid #ddd', fontSize: '11px', color: 'whitesmoke', padding: '2px', fontWeight: 'bold', textTransform: 'uppercase' }}>Description</TableCell>
                                <TableCell sx={{ backgroundColor: '#102E50', borderBottom: '1px solid #ddd', fontSize: '11px', color: 'whitesmoke', textAlign: 'right', padding: '2px', fontWeight: 'bold', textTransform: 'uppercase' }}>Debit</TableCell>
                                <TableCell sx={{ backgroundColor: '#102E50', borderBottom: '1px solid #ddd', fontSize: '11px', color: 'whitesmoke', textAlign: 'right', padding: '2px', fontWeight: 'bold', textTransform: 'uppercase' }}>Credit</TableCell>
                                <TableCell sx={{ backgroundColor: '#102E50', borderBottom: '1px solid #ddd', fontSize: '11px', color: 'whitesmoke', textAlign: 'right', padding: '2px', fontWeight: 'bold', textTransform: 'uppercase' }}>Balance</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {filteredDataItem.map((data, index) => (
                                <TableRow key={data.id} sx={data.description1 === 'Opening Balance' || data.description1 === 'Closing Balance' || data.description1 === 'Total' ? { backgroundColor: '#f0f0f0' } : null} >
                                    {data.description === 'Opening Balance' || data.description1 === 'Closing Balance' || data.description1 === 'Total' ? (
                                        <TableCell sx={{ padding: '5px', fontWeight: 'bolder' }}></TableCell>
                                    ) : (
                                        <TableCell sx={{ padding: '5px' }}>{formatDate(data.date1)}</TableCell>
                                    )}
                                    <TableCell
                                        sx={{
                                            //fontSize: '15px',
                                            height: '30px',
                                            padding: '7px',
                                            fontWeight:
                                                data.description1 === 'Opening Balance' ||
                                                    data.description1 === 'Closing Balance' ||
                                                    data.description1 === 'Total'
                                                    ? 'bolder'
                                                    : 'normal',
                                        }}
                                    >
                                        {data.tbl1 === 'Sale' ? (
                                            <a
                                                href={`/SaleDetails/${data.id}`}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                style={{ color: 'darkgreen' }}
                                            >
                                                {data.description1}
                                            </a>
                                        ) : data.tbl1 === 'SaleReturn' ? (
                                            <a
                                                href={`/SaleReturnDetails/${data.id}`}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                style={{ color: 'red' }}
                                            >
                                                {data.description1}
                                            </a>
                                        )
                                            : data.tbl1 === 'Receipt UPI' ? (
                                                <a
                                                    href={`/ReceiptDetails/${data.id}`}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    style={{ color: '#604652' }}
                                                >
                                                    {data.description1}
                                                </a>
                                            )
                                                : data.tbl1 === 'Receipt Cheque' ? (
                                                    <a
                                                        href={`/ReceiptDetails/${data.id}`}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        style={{ color: '#604652' }}
                                                    >
                                                        {data.description1}
                                                    </a>
                                                )
                                                    : data.tbl1 === 'Receipt Cash' ? (
                                                        <a
                                                            href={`/ReceiptDetails/${data.id}`}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            style={{ color: '#604652' }}
                                                        >
                                                            {data.description1}
                                                        </a>

                                                    )
                                                        : data.tbl1 === 'JournalCustomer1' ? (
                                                            <a
                                                                href={`/JournalEntryDetails/${data.id}`}
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                                style={{ color: 'darkorchid' }}
                                                            >
                                                                {data.description1}
                                                            </a>
                                                        )
                                                            : data.tbl1 === 'JournalCustomer2' ? (
                                                                <a
                                                                    href={`/JournalEntryDetails/${data.id}`}
                                                                    target="_blank"
                                                                    rel="noopener noreferrer"
                                                                    style={{ color: 'darkorchid' }}
                                                                >
                                                                    {data.description1}
                                                                </a>
                                                            )
                                                                : data.tbl1 === 'JournalSupplier1' ? (
                                                                    <a
                                                                        href={`/JournalEntryDetails/${data.id}`}
                                                                        target="_blank"
                                                                        rel="noopener noreferrer"
                                                                        style={{ color: 'darkslategray' }}
                                                                    >
                                                                        {data.description1}
                                                                    </a>

                                                                )
                                                                    : data.tbl1 === 'JournalSupplier2' ? (
                                                                        <a
                                                                            href={`/JournalEntryDetails/${data.id}`}
                                                                            target="_blank"
                                                                            rel="noopener noreferrer"
                                                                            style={{ color: 'darkslategray' }}
                                                                        >
                                                                            {data.description1}
                                                                        </a>
                                                                    )
                                                                        : data.tbl1 === 'JournalBank1' ? (
                                                                            <a
                                                                                href={`/JournalEntryDetails/${data.id}`}
                                                                                target="_blank"
                                                                                rel="noopener noreferrer"
                                                                                style={{ color: 'darkmagenta' }}
                                                                            >
                                                                                {data.description1}
                                                                            </a>
                                                                        )
                                                                            : data.tbl1 === 'JournalBank' ? (
                                                                                <a
                                                                                    href={`/JournalEntryDetails/${data.id}`}
                                                                                    target="_blank"
                                                                                    rel="noopener noreferrer"
                                                                                    style={{ color: 'darkmagenta' }}
                                                                                >
                                                                                    {data.description1}
                                                                                </a>
                                                                            )
                                                                                : data.tbl1 === 'JournalAccountHead' ? (
                                                                                    <a
                                                                                        href={`/JournalEntryDetails/${data.id}`}
                                                                                        target="_blank"
                                                                                        rel="noopener noreferrer"
                                                                                        style={{ color: 'darkmagenta' }}
                                                                                    >
                                                                                        {data.description1}
                                                                                    </a>
                                                                                )

                                                                                    : data.tbl1 === 'Payment Cash' ? (
                                                                                        <a
                                                                                            href={`/PaymentDetails/${data.id}`}
                                                                                            target="_blank"
                                                                                            rel="noopener noreferrer"
                                                                                            style={{ color: 'darkviolet' }}
                                                                                        >
                                                                                            {data.description1}
                                                                                        </a>
                                                                                    )
                                                                                        : data.tbl1 === 'Payment Cheque' ? (
                                                                                            <a
                                                                                                href={`/PaymentDetails/${data.id}`}
                                                                                                target="_blank"
                                                                                                rel="noopener noreferrer"
                                                                                                style={{ color: 'darkviolet' }}
                                                                                            >
                                                                                                {data.description1}
                                                                                            </a>
                                                                                        )
                                                                                            : data.tbl1 === 'Payment UPI' ? (
                                                                                                <a
                                                                                                    href={`/PaymentDetails/${data.id}`}
                                                                                                    target="_blank"
                                                                                                    rel="noopener noreferrer"
                                                                                                    style={{ color: 'darkviolet' }}
                                                                                                >
                                                                                                    {data.description1}
                                                                                                </a>
                                                                                            )
                                                                                                : data.tbl1 === 'Purchase' ? (
                                                                                                    <a
                                                                                                        href={`/PurchaseDetails/${data.id}`}
                                                                                                        target="_blank"
                                                                                                        rel="noopener noreferrer"
                                                                                                        style={{ color: 'darkcyan' }}
                                                                                                    >
                                                                                                        {data.description1}
                                                                                                    </a>
                                                                                                )
                                                                                                    : data.tbl1 === 'PurchaseReturn' ? (
                                                                                                        <a
                                                                                                            href={`/PurchaseReturnDetails/${data.id}`}
                                                                                                            target="_blank"
                                                                                                            rel="noopener noreferrer"
                                                                                                            style={{ color: 'red' }}
                                                                                                        >
                                                                                                            {data.description1}
                                                                                                        </a>

                                                                                                    ) : (
                                                                                                        data.description1
                                                                                                    )}
                                    </TableCell>
                                    <TableCell sx={{ fontSize: '14px', height: '30px', padding: '5px', textAlign: 'right', fontWeight: data.description1 === 'Opening Balance' || data.description1 === 'Closing Balance' || data.description1 === 'Total' ? 'bolder' : 'normal' }}> {data.debit != null ? data.debit.toFixed(2) : ''}</TableCell>
                                    <TableCell sx={{ fontSize: '14px', height: '30px', padding: '5px', textAlign: 'right', fontWeight: data.description1 === 'Opening Balance' || data.description1 === 'Closing Balance' || data.description1 === 'Total' ? 'bolder' : 'normal' }}> {data.credit != null ? data.credit.toFixed(2) : ''}</TableCell>
                                    <TableCell
                                        sx={{
                                            fontSize: '14px',
                                            height: '30px',
                                            padding: '5px',
                                            textAlign: 'right',
                                            width: '150px',
                                            fontWeight: 'bolder',
                                        }}
                                    >
                                        {computeBalance(data)}
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>

            </div>
        </div>
    );
}

export default Ledger;
